import React from 'react';
import { Alert, Label } from 'reactstrap';
import FormikInputField from '~/components/formikInputField/formikInputField';
import FormLayout from '~/components/formLayout/formLayout';
import SubmissionButton from '~/components/submissionButton/submissionButton';

const LocationForm = ({ errors, touched, handleSubmit, isSubmitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <FormLayout title="Location overview">
        <div className="mb3">
          <Label>Name</Label>
          <FormikInputField name="name" invalid={!!errors.name} />
          {errors.name && (
            <p data-qa="name-error" className="error">
              {errors.name}
            </p>
          )}
        </div>
      </FormLayout>
      <FormLayout className="mt4" title="Notes">
        <div className="mb3">
          <Label>Notes</Label>
          <FormikInputField type="textarea" name="notes" />
        </div>
      </FormLayout>
      <div className="flex justify-end mt4">
        <SubmissionButton color="primary" type="submit" isSubmitting={isSubmitting}>
          Save
        </SubmissionButton>
      </div>
    </form>
  );
};

export default LocationForm;



// WEBPACK FOOTER //
// ./src/components/locationForm/locationForm.jsx